import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

const EmptyText = styled.p`
  font-size: 15rem;
  color: #90A1B0;
`

const CenterTextContainer = styled.section`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Empty = ({children}) => (
  <CenterTextContainer>
    <EmptyText>{children}</EmptyText>
  </CenterTextContainer>
)

Empty.propTypes = {
  children: PropTypes.any
}

export default Empty

